// removed by extract-text-webpack-plugin
module.exports = {"cv":"src-pages----amelie-module---cv---3upzT"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/amelie.module.css
// module id = 253
// module chunks = 106391149878696